import { BaseError } from '@adornis/validation/errors/BaseError.js';

/**
 * An error that is part of a resolver's normal control flow rather than a server fault:
 * an authorization denial, a stale-client state mismatch, a record the caller may not see.
 *
 * BaseQL's websocket server logs a failed operation at `error` level — which is what the
 * "Error Logs" Grafana alert fires on — unless the thrown error carries
 * `extensions.onlyInfoLog`, in which case it logs at `info` level instead
 * (@adornis/baseql `server/server.ts`, `startOperation`). GraphQL propagates
 * `originalError.extensions` onto the wrapping GraphQLError, so setting the flag on the
 * error we throw inside a resolver reaches that check.
 *
 * The error still reaches the client with the same message — only its log level changes.
 * Use it for conditions a client can legitimately produce; keep plain `throw new Error`
 * for invariants that mean the server is broken.
 *
 * Mirrored in `@nsc/smartteams-shared` (`api/expected-error.ts`); this package cannot import
 * from there, because it is a dependency of that package.
 */
export const expectedError = (message: string, extensions: Record<string, unknown> = {}): BaseError =>
  new BaseError(message, { ...extensions, onlyInfoLog: true });
